<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {}
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  /* user-select: none; */
  
}
ul,
li {
  list-style: none;
}

body{
  font-family: PingFangSC-Medium, PingFang SC;
}
#app {
  width: 100vw;
  height: 100vh;
}

//滚动条样式
::-webkit-scrollbar {
    width: 12px;
    height: 4px;
}

::-webkit-scrollbar-thumb {
    border-radius: 12px;
    border: 2px solid rgba(0, 0, 0, 0);
    box-shadow: -10px 0 0 #C7C7C7 inset;
    transition: 0.3s;
    &:hover {
        box-shadow: -10px 0 0 #878787 inset;
    }
}
//选中效果
// ::selection {
//   background: rgba(32, 178, 170, 0.6);
//   color: #ffffff;
// }

// ::-moz-selection {
//   background: rgba(32, 178, 170, 0.6);
//   color: #ffffff;
// }

</style>
